// @ts-ignore
export const all = (state) => state.all;
// @ts-ignore
export const isAllLoaded = (state) => state.loadAll;
export const one = (state) => (id) => {
  return state.all.filter((post) => post.id === id)[0];
};
